var React = require('react');

function TwitterXIconBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"X","d":"M14.7331 10.1571L23.4711 0H21.4004L13.8133 8.81931L7.75346 0H0.76416L9.92782 13.3364L0.76416 23.9877H2.83489L10.8471 14.6742L17.2467 23.9877H24.236L14.7326 10.1571H14.7331ZM11.897 13.4538L10.9685 12.1258L3.581 1.55881H6.76152L12.7233 10.0867L13.6518 11.4147L21.4014 22.4998H18.2209L11.897 13.4544V13.4538Z","fill":"#3D5265"}));
}

TwitterXIconBlue.defaultProps = {"width":"18","height":"18","viewBox":"0 0 25 24","fill":"none"};

module.exports = TwitterXIconBlue;

TwitterXIconBlue.default = TwitterXIconBlue;
